module.exports = __webpack_public_path__ + "static/media/examination-header-img1.6cd00860.png";